/** The only link target the API mints today. */
export const LINK_TARGET_WORKFLOW = 'WORKFLOW';

/**
 * Response of the token resolve endpoint, telling the app which flow a branded link opens.
 *
 * `type` is deliberately a plain string rather than a union of the known values: the API can
 * grow target types that a deployed build predates, and the entry point has to recognise one
 * it does not know instead of assuming every response is a workflow.
 */
export interface LinkResolveResponse {
  type: string;
  targetId: string;
}
